import { create } from "zustand"

type EditChapterDialogState = {
    isOpen: boolean
}

type EditChapterDialogActions = {
    onOpen: () => void
    onClose: () => void
}

const useEditChapterDialogV1 = create<
    EditChapterDialogState & EditChapterDialogActions
>((set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),
}))

export default useEditChapterDialogV1
